<style scoped>

    .img-pop {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 70%;
        margin-left: -35%;
        margin-top: -30%;
        border: 0 solid #D3D3D3;
        border-radius: 0.13rem;
        z-index: 1999;
        background: #fff;
    }

    .img-pop p {
        text-align: center;
        padding: 0.26rem 0;
        font-size: 0.5rem;
    }

    .img-pop input {
        display: inline-block;
        width: 60%;
        height: 80%;
        border: none;
        outline: none;
        background: transparent;
        border-right: 1px solid #D3D3D3;
        padding-left: 5px;
        font-size: 0.5rem;
        vertical-align: middle;
    }

    .img-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .6);
        z-index: 99;
    }

    .code-wrap {
        border: 1px solid #D3D3D3;
        margin: 0 0.2rem 0.2rem;
        border-radius: 4px;
        height: 1.2rem;
        line-height: 1.2rem;
    }
    .code-wrap {
        font-size: 0.2rem;
    }
    .btn-wrap {
        text-align: center;
        padding-bottom: 0.2rem;
        font-size: 0.2rem;
    }

    .btn-wrap span {
        display: inline-block;
        vertical-align: middle;
        font-size: 0.5rem;
        color: #D9A378;
    }

    .img-code-btn {
        display: inline-block;
        vertical-align: middle;
        width: 36%;
        overflow: hidden;
        text-align: center;
    }

    .img-code-btn img {
        width: 100%;
        margin-left: -5px;
    }

</style>
<template>
    <div>
        <div class="img-pop" v-if="isShow">
            <p>请输入验证码</p>
            <div class="code-wrap">
                <input type="text" v-model="code" @blur="fixWindow">
                <span class="img-code-btn" @click="getImg"><img :src="imgCode"></span>
            </div>
            <div class="btn-wrap">
                <span class="pop-btn" @click="getCode">确定</span>
            </div>
        </div>
        <div v-show="showBgMask" class="toast-mask"></div>
    </div>
</template>
<script>
    import { GetImgCode, GetPhoneMessage } from '@/query/api'
    import { todoRel } from '@/assets/js/common'
    import { sm2Encrypt } from '@/utils/sm2Util'
    import { mapMutations } from 'vuex'
    import config from '@/config/config'
    import { getGTHeaders } from '../utils/geetest'

    export default {
        name: 'imgCode',
        props: {
            show: {
                type: Boolean,
                default: false
            },
            phone: String,
            codeType: Number,
            verifyInfoData: {
                type: Object,
                default: null
            }
        },
        data () {
            return {
                code: '',
                codeKey: '',
                imgCode: '',
                isPost: true,
                calculationTime: 60,
                showBgMask: false,
                timeInterval: '',
                isShow: false
            }
        },
        watch: {
            show: function (val) {
                if (val === true) {
                    this.isShow = true
                    this.code = ''
                    this.getImg()
                }
            }
        },
        methods: {
            ...mapMutations(['timeChange']),
            fixWindow () {
                window.scrollTo(0, 0)
            },
            tips (msg) {
                this.showBgMask = true
                this.$message({
                    message: msg,
                    duration: 1000
                })
            },
            getCodeKey (res) {
                // 获取图形验证码
                this.imgCode = config.JAVA_SERVER + 'atourlife/verifyCode/getCodeImage?codeKey=' + res + '&appVer=1.4.0&channelId=3000001&platType=3'
                this.codeKey = res
                this.showBgMask = true
            },
            getImg () {
                GetImgCode({}).then(rel => {
                    todoRel(rel, () => {
                        this.getCodeKey(rel.result)
                    }, () => {
                        this.tips(rel.retmsg)
                    })
                })
            },
            countDown () {
                if (this.timeInterval) {
                    clearInterval(this.timeInterval)
                }
                this.timeInterval = setInterval(() => {
                    if (this.calculationTime > 0) {
                        this.calculationTime--
                        this.timeChange(this.calculationTime)
                    } else {
                        this.calculationTime = 60
                        clearInterval(this.timeInterval)
                        this.timeChange('重新获取')
                        this.$emit('showChange', false)
                    }
                }, 1000)
            },
            getCode () {
                // 获取短信验证码
                console.log(this.code)
                if (!this.code) {
                    this.tips('验证码为空')
                } else {
                    let param = {
                        phoneNum: sm2Encrypt(this.phone) || null,
                        code: this.code,
                        codeKey: this.codeKey,
                        type: this.codeType
                    }
                    const headers = getGTHeaders('getCode')
                    console.log('verifyInfoData result======', headers)

                    GetPhoneMessage({params: param, config: headers}).then(rel => {
                        todoRel(rel, () => {
                            this.getCodeKey(rel.result)
                            this.tips('验证码发送成功,请注意查收')
                            localStorage.setItem('startTime', new Date().getTime())
                            this.countDown()
                            this.changeImgCode()
                        }, () => {
                            this.tips(rel.retmsg)
                            this.changeImgCode()
                        })
                    })
                }
            },
            changeImgCode () {
                this.isShow = false
                this.$emit('showChange', this.isShow)
                this.showBgMask = false
            },
            inspectTime () {
                let startTime = localStorage.getItem('startTime')
                let nowTime = new Date().getTime()
                let differ = parseInt((nowTime - startTime) / 1000) // 时间差
                if (differ > 60) {
                    localStorage.setItem('startTime', new Date().getTime())
                } else if (differ < 60) {
                    this.calculationTime = 60 - differ
                    this.countDown()
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/imgCode.vue